import type { CatalogItem } from '~/models/common'

export const gamePlatforms: CatalogItem[] = [
  {
    label: 'Android',
    value: 12,
  },
  {
    label: 'iOS',
    value: 13,
  },
  {
    label: 'Other',
    value: 14,
  },
  {
    label: 'PC',
    value: 16,
  },
  {
    label: 'Playstation',
    value: 8,
  },
  {
    label: 'Switch',
    value: 7,
  },
  {
    label: 'VR / AR',
    value: 1,
  },
  {
    label: 'Web / Cloud',
    value: 20,
  },
  {
    label: 'Xbox',
    value: 9,
  },
]
